import { getBannerImages } from 'utils/banner/utils';
import { BannerImageCropType } from 'utils/constants/banner';

import { BannerErrors, CreateBannerState } from 'store/models/createBanner';
import { CampaignErrors } from 'store/models/createCampaign';

export interface BannerValidatorDto {
    [key: string]: string;
}

export const BANNER_FIELDS_MAPPING: Record<string, keyof BannerErrors> = {
    title: 'bannerTitle',
    text: 'bannerText',
    url: 'bannerLink',
    bannerImages: 'images',
    classificationCodeId: 'classificationCodeId',
};

interface Fields {
    [x: string]: unknown;
}

interface GetValidateBannerFieldsData {
    objectToValidate: Record<string, unknown>;
    fieldsToValidate: string[];
}

export const getValidateBannerFields = (
    state: Partial<CreateBannerState>,
    activeCropTypes: BannerImageCropType[]
): GetValidateBannerFieldsData => {
    const fields: Fields = {};
    const { images } = state;
    const bannerImages = images && getBannerImages(images, activeCropTypes);

    const computedFields: Record<string, unknown> = {
        bannerImages,
    };
    Object.entries(BANNER_FIELDS_MAPPING).forEach(([keyMapping, stateKey]) => {
        if (computedFields.hasOwnProperty(keyMapping)) {
            fields[keyMapping] = computedFields[keyMapping];
        } else {
            fields[keyMapping] = state[stateKey];
        }
    });
    return {
        objectToValidate: fields,
        fieldsToValidate: Object.keys(fields),
    };
};

export const getValidateBannerErrors = (errors: BannerValidatorDto): Partial<BannerErrors> => {
    const fields: Partial<CampaignErrors & BannerErrors> = {};
    Object.entries(BANNER_FIELDS_MAPPING).forEach(([keyMapping, stateKey]) => {
        fields[stateKey] = errors[keyMapping];
    });
    return fields;
};
